import { ViewerCommand } from './ViewerCommand';
import { Vector3 } from 'three';
import { ViewerEvents } from '../../Viewer';
export class SetScaleCommand extends ViewerCommand {
    constructor(viewer, objects, newScales, optionalOldScales) {
        var _a;
        super(viewer, objects);
        this.type = 'SetScaleCommand';
        this.name = this.composeName();
        this.updatable = true;
        this.newScales = newScales.map((scale) => scale.clone());
        this.oldScales = (_a = optionalOldScales === null || optionalOldScales === void 0 ? void 0 : optionalOldScales.map((scale) => scale.clone())) !== null && _a !== void 0 ? _a : objects.map((object) => object.scale.clone());
    }
    execute() {
        this.objects.forEach((object, index) => {
            object.scale.copy(this.newScales[index]);
            object.updateMatrixWorld(true);
        });
        this.viewer.emit(ViewerEvents.SetObjectsScale, this.objects.map((object) => object.uuid));
    }
    undo() {
        this.objects.forEach((object, index) => {
            object.scale.copy(this.oldScales[index]);
            object.updateMatrixWorld(true);
        });
        this.viewer.emit(ViewerEvents.SetObjectsScale, this.objects.map((object) => object.uuid));
    }
    update(cmd) {
        if (this.newScales.length !== cmd.newScales.length) {
            throw Error(`Invalid update of ${this.type}. newScales member must have equal length`);
        }
        this.newScales.forEach((scale, index) => scale.copy(cmd.newScales[index]));
    }
    toJSON() {
        const output = super.toJSON();
        output.oldScales = this.oldScales.map((scale) => scale.toArray());
        output.newScales = this.newScales.map((scale) => scale.toArray());
        return output;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.oldScales = json.oldScales.map((scale) => new Vector3().fromArray(scale));
        this.newScales = json.newScales.map((scale) => new Vector3().fromArray(scale));
    }
}
